export default __webpack_public_path__ + "static/observian-cloud-58ad5460f596004e9cf1be1e2b640ead.png";